// Peso de rubro: 0-100 con máximo 1 decimal (acepta coma como punto).
const WEIGHT_RE = /^(100(\.0?)?|\d{1,2}(\.\d?)?)?$/;

export const normalizeWeightInput = (raw) => {
  const v = String(raw ?? '').replace(',', '.').trim();
  return WEIGHT_RE.test(v) ? v : null;
};

export const parseWeight = (v) => parseFloat(v) || 0;
